import { PathwayDto } from './pathway.dto';

export class Pathway {
    id: number;
    name: string;
    coursesIds: string[];
    constructor(data: PathwayDto) {
        this.id = data.id;
        this.name = data.name;
        this.coursesIds = data.courseIds;
    }
}
